import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

import Greeting from "./greeting";
import ContextMenu from "../widgets/contextMenu";
import ShortcutItem from "./shortcutItem";

import { QuickLinkContainer } from "../../styled/dashboard";
import { onFullscreen } from "../../../../kiosk/component/function/kiosk";
import { monotiService, specialShortcuts, openAdmin } from "../../function/dashboard";
import { useSelector } from "react-redux";

const QuickLinks = ({
  setting,
  isDragEnabled,
  setActiveIndex,
  deleteQuick,
  editQuick,
  setIsMenuOpen,
  menuRef,
  isMenuOpen,
}) => {
  const navigate = useNavigate();
  const ellipseRef = useRef();

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const company = useSelector((state) => state?.company?.data);
  const user = useSelector((state) => state?.user?.data[0]);

  const [positions, setPositions] = useState([]);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isMobile) {
      calcPositions();
    } else {
      setPositions([]);
    }
  }, [setting.shortcuts, isMobile]);

  const calcPositions = () => {
    const ellipse = ellipseRef.current;
    const ellipseWidth = ellipse.offsetWidth / 2;
    const ellipseHeight = ellipse.offsetHeight / 2;
    const numChildren = setting.shortcuts.length;
    const gapAngle = (2 * Math.PI) / numChildren;

    const newPositions = setting.shortcuts.map((_, index) => {
      const angle = index * gapAngle - Math.PI / 2;

      const x = ellipseWidth + ellipseWidth * Math.cos(angle);
      const y = ellipseHeight + ellipseHeight * Math.sin(angle);
      return { left: x, top: !index ? y + 9 : y };
    });

    setPositions(newPositions);
  };

  // 바로가기 버튼 클릭
  const clickQuickLink = async (item) => {
    if (!item?.url) return toast.error("이동할 수 없는 페이지입니다.");

    try {
      let url = item.url;

      // 관리자 페이지
      if (/^https?:\/\/admin\.1472\.ai:3002/.test(url)) {
        return await openAdmin(user);
      }

      // www 로 시작할 경우
      if (url.startsWith("www")) url = `https://${url}`;

      // 외부 URL
      if (/^(https?|www)/.test(url)) return window.open(url, "_blank");

      // 내부 경로
      if (url === "/mypage/store") {
        const stores = company.filter((c) => c.gbn === "ss" || c.cmpnyNo === 16421);
        if (!stores.length) return toast.error("회사가 존재하지 않습니다.");
        onFullscreen();
      }

      url === "/mypage/kiosk" ? (window.location.href = url) : navigate(url);
    } catch (error) {
      console.error(error);
      toast.error("페이지 이동 중 오류가 발생했습니다.");
    }
  };

  // 메뉴 버튼 클릭
  const handleMenuButtonClick = (e, index) => {
    if (isDragEnabled) return;

    const button = e.target.closest("button");

    if (button) {
      const rect = button.getBoundingClientRect();
      setMenuPosition({ x: rect.left, y: rect.top });
    }

    setActiveIndex(index);
    setIsMenuOpen(true);
  };

  const isPresetShortcut = (item, index) => {
    const shortcuts = [...setting.shortcuts];

    const adminUrl = "http://admin.1472.ai:3002/auth/login";
    const adminIndexes = shortcuts
      .map((s, i) => (s.url === adminUrl ? i : -1))
      .filter((i) => i !== -1);

    const isFirstAdmin = item.url === adminUrl && index === adminIndexes[0];

    const allShortcuts = [...specialShortcuts, ...monotiService];
    const duplicateIndex = shortcuts
      .map((shortcut, i) =>
        shortcut.icon === item.icon && shortcut.url === item.url && shortcut.label === item.label
          ? i
          : -1,
      )
      .filter((i) => i !== -1);

    const isPredefined =
      allShortcuts.some(
        (shortcut) =>
          shortcut.icon === item.icon && shortcut.url === item.url && shortcut.label === item.label,
      ) && duplicateIndex[0] === index;

    return isFirstAdmin || isPredefined;
  };

  return (
    <QuickLinkContainer>
      <div className="ellipse" ref={ellipseRef}>
        {isMenuOpen && (
          <ContextMenu
            setting={setting}
            menuPosition={menuPosition}
            currentMenuItems={[
              { name: "바로가기 수정", action: editQuick },
              { name: "삭제", action: deleteQuick },
            ]}
            menuRef={menuRef}
            setIsMenuOpen={setIsMenuOpen}
          />
        )}
        {!isMobile && <Greeting />}
        {setting.shortcuts.map((item, index) => (
          <ShortcutItem
            key={index}
            position={positions[index]}
            imgSrc={`/img/quickLinks/${item.icon || "not"}.png`}
            label={item.label}
            customContent={!item.icon && <span className="not">{item.label.slice(0, 1)}</span>}
            onClick={() => clickQuickLink(item)}
            showMenuButton={!isPresetShortcut(item, index)}
            onMenuClick={(e) => handleMenuButtonClick(e, index)}
          />
        ))}
      </div>
    </QuickLinkContainer>
  );
};

export default QuickLinks;
